// Arma los query params de GET /providers/all para la lista de Proveedores
// Recomendados de Cerrajeria: solo cerrajeros activos del estado y ciudad de
// origen. Devuelve null si falta la ubicacion para no consultar sin filtro.
// Si se pasan las ciudades cargadas del estado, la ciudad debe estar entre
// ellas: al cambiar el estado el form conserva la ciudad anterior hasta que
// el usuario elige otra, y no se debe consultar con un par estado/ciudad mezclado.
export const buildLocksmithProvidersParams = ({ state, city, cities } = {}) => {
  if (!state || !city) return null;
  if (cities && !cities.some((option) => option?._id === city)) return null;
  return { type: "Cerrajero", isActive: true, state, city };
};
